import {createReducer, isAnyOf} from '@reduxjs/toolkit'
import {omit} from 'lodash'
import {DETAILS_ROUTE} from '../../../../commons/constants/navigation'
import {changeEventAction} from '../actions/event'
import {navigate, navigateBack, removeCheckoutQueryParams} from '../actions/navigation'
import {Navigation} from '../types/state'

const defaultState: Navigation = {
  sectionPath: '',
  slug: '',
  route: DETAILS_ROUTE.DETAILS,
  query: {},
  shouldNavigateBack: false,
}

export const navigation = createReducer(defaultState, builder => {
  builder
    .addCase(changeEventAction, (state, action) => {
      return {
        ...state,
        slug: action.payload.event.slug,
      }
    })
    .addCase(navigate.fulfilled, (state, action) => {
      if (action.payload) {
        return {
          ...state,
          ...action.payload,
        }
      }
    })
    .addCase(navigateBack, state => {
      state.shouldNavigateBack = true
    })
    .addMatcher(isAnyOf(navigateBack, removeCheckoutQueryParams), state => {
      state.query = omit(state.query, ['reservationId', 'orderNumber'])
    })
})
